
export * from '../../frontend-js-dependencies-web/__liferay__/exports/image-promise.js';

import __default__ from '../../frontend-js-dependencies-web/__liferay__/exports/image-promise.js';
export default __default__;
